
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const neve1073opxDante: IProductData = {
  id: "neve-1073opx-dante",
  name: "Neve Eight Mic Preamp with Dante",
  description: "Packing eight 1073® remote-controllable preamps in a 2U rackmount case, the 1073OPX suits modern DAW-based workflows, where space is at a premium, whilst also offering that 1073 sound everyone knows and loves. It’s the Swiss Army knife for modern studios.",
  specialOrder: true,
  images: ["/img/neve_1073OPX_front.png", "/img/neve_1073OPX_back.png"],
  details: [{
    label: "Description",
    markdown: `
The 1073OPX USB/ADAT Card is a powerful digital expansion card using the universally accepted ADAT protocol. This digital option card includes two modes of operation:

USB/ADAT Hub mode – Transforms the 1073OPX into an expandable USB Audio Interface, capable of connecting up to 16 inputs and 10 outputs through a single USB connection.
ADAT standalone mode – Allows users to expand an existing ADAT-compatible audio interface digitally via ADAT optical connection, adding eight Neve 1073 preamps and additional stereo output to their existing audio interface.

Every switch setting gain position and routing option can be remotely controlled from the 1073OPX app. This feature unlocks vast potential for many modern studios, live sound venues and broadcast suites. In addition, up to eight OPX units can be remotely controlled from the OPX app for 64 total remote-controlled 1073® preamps!

The groundbreaking 1073OPX optional digital card provides premium AD/DA conversion up to 192kHz for all eight preamps, plus a stereo digital monitor return. For professionals looking to connect to a Dante audio-over-IP network, dual ethernet ports allow for redundancy via primary and secondary connections or for home studio users the class-compliant USB 2.0 connection transforms the 1073OPX preamp into a complete studio audio interface.

The eight microphone preamps are balanced using our patented Marinair® transformers. This crucial element produces a sublime preamp quality and tone that is unmatched in the audio industry.

The 1073OPX preamps are controlled from the stepped gain encoder in 1dB steps. This feature offers ultimate accuracy for stereo pairs and instrument groups through local or remote control.

Three inputs for microphone, line and instrument with independent gain settings & connections provide ideal recording inputs for the modern studio environment.

The instrument DI uses a unique class-A design and FET transistor to produce musical colouration and high performance for any connected instrument.

The innovative phantom power circuit uses built-in intelligence to ensure that the +48v is only sent to the microphone input, no matter what is connected. The -25dB of attenuation provided by the PAD switch is essential when recording a wide range of inputs and microphone types, whilst the 180-degree phase flip feature is handy in multi-microphone setups with multiple preamps. The 80Hz 12dB/Octave filter is perfect for cutting unwanted bass frequencies when recording higher register instruments.

The impedance switch toggles between 1.2kOhms and 300Ohms. These two settings optimise the preamp impedance for any modern or vintage microphone.

The 1073OPX has both front and rear input connections with independent switching. This layout allows for complete integration into a studio rack and a simple direct link to the front of the unit at any time without having to re-patch.

The 1073OPX analogue and digital monitor paths are ideal for connecting to studio loudspeakers with front-mounted headphone monitoring connections. In addition, each preamp output can be routed into the monitor path for latency-free monitoring or analogue summing.
`
    }, {
      label: "Specifications",
      markdown: `
• 8 Channels of remote-controlled 1073® Mic/Line/Instrument Preamplifiers.
• Exclusive Neve® Marinair® transformers on Microphone input.
• Class-A transformer-less DI input
• Remote control software can control up to eight 1073OPX racks at a time (64 preamps!)
• Automatic Total Recall™ of all settings.
• Front Mic/Line combi input
• Rear Mic/Line D-Type connection
• 80Hz High pass filter
• -25dB pad
• Phase flip
• Smart Phantom Power control
• Hi/Lo Impedance selector from 300Ω to 1.3KΩ
• Separate stereo monitor path with Independent level control
• Latency-free monitoring of all signal sources
• Eight front D.I inputs for instrument tracking
• Front-mounted Headphone output
• Heat Dissipation 40 Watts
• Input voltage range 90-240V
`
}, {
    label: "Digital Card (optional add on) General Specification",
  markdown: `
• USB connection for use as standalone primary audio interface/core audio device.
• Dante Primary and Secondary connection for Audio-over-IP application.
• Word Clock Sync In/Out
• Selectable Headroom from +18, +24, +26dB
`
  }, {
    label: "Audio Performance",
    markdown: `
• Headroom: >+26dBu @ 1kHz (<0.5% THD+N)
• Frequency Response: Typically +/-0.15dB, 20Hz to 20kHz
• Distortion (THD+N): Typically 0.002% @ 1kHz (measured at +20dBu, 10Hz to 80kHz filter)
• General Noise: <-85dBu (20Hz to 22kHz filter)
• Mic EIN Noise: Typically -125dBu (20Hz to 20kHz)
• Microphone Inputs: Input Impedance ≈300Ω or ≈1.3kΩ (PAD out). Transformer coupled. Gain 20dB to 70dB in 1dB steps
• Line Inputs: Input Impedance ≈10kΩBridging(PAD out). Gain -20dB to +20dB in 1dB steps
• DI Inputs: Input Impedance >650kΩ. Transformer-less Class A Gain 30dB to 60dB in 1dB steps
`
  }, {
    label: "AD/DA Card Specification",
    markdown: `
• Noise: > -118dBFS
• Dynamic Range: 120dB
• Distortion: <0.0007%
• RTL: 4.01ms (192kHz, 32 buffer)
  `
  }, {
  label: "Dimensions",
  markdown: `
• Height: 89mm/3.5 inches (2U)
• Width: 484mm/19.05 inches (19″ rack)
• Depth: 360mm/14.17 inches
• Weight: 7.8Kg
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/outboard/1073-range/1073opx/" target="_blank">https://www.ams-neve.com/outboard/1073-range/1073opx/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MICPRE, HASHTAGS.RECORDING, HASHTAGS.LIVE_SOUND, HASHTAGS.TWO_U, HASHTAGS.RACK],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}